import { render, staticRenderFns } from "./tsk-text.vue?vue&type=template&id=d74dee60&scoped=true&"
import script from "./tsk-text.vue?vue&type=script&lang=js&"
export * from "./tsk-text.vue?vue&type=script&lang=js&"
import style0 from "./tsk-text.vue?vue&type=style&index=0&id=d74dee60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74dee60",
  null
  
)

export default component.exports